/**
 * Default metrics event topic name.
 *
 * @remarks
 * For predictable behavior, this should match the fallback in metrics pipeline topic.
 */
export const DEFAULT_EVENT_TOPIC = 'xp_amp_music-classical_main'; // TODO this is a made up topic and needs to change based on actual metrics topic
